module.exports = __webpack_public_path__ + "img/icon-close.98cc916f.svg";